import { useEffect, useState } from "react";
import { Box, Tooltip, useTheme } from "@mui/material";
import { useMemo } from "react";

export default function AllSidesCategoryIcon({
  category,
  color,
  active,
  size,
  title,
}) {
  const theme = useTheme();
  // const [dimension, setDimension] = useState("1.5rem");
  // const [fontSize, setFontSize] = useState("1.3rem");
  const dimension = useMemo(() => {
    switch (size) {
      case "small":
        return "1.5rem";
      case "large":
        return "2.4rem";
      default:
        return "1.5rem";
    }
  }, [size]);
  const fontSize = useMemo(() => {
    switch (size) {
      case "small":
        return "1.2rem";
      case "large":
        return "2.2rem";
      default:
        return "1.3rem";
    }
  }, [size]);
  const bgColor = useMemo(() => {
    return active
      ? color
      : theme.palette.grey[600];
  }, [color, active, theme]);
  return (
    <Tooltip title={title}>
      <Box
        width={dimension}
        height={dimension}
        sx={{
          backgroundColor: bgColor,
          color: theme.palette.getContrastText(bgColor),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          p: 0,
          fontSize: fontSize,
        }}
      >
        {category}
      </Box>
    </Tooltip>
  );
}
